const filenameArray = [
    'longitude-voiceover_01.mp3',
    'longitude-voiceover_02.mp3',
    'longitude-voiceover_03.mp3',
    'longitude-voiceover_04.mp3',
    'longitude-voiceover_05.mp3',
    'longitude-voiceover_06.mp3',
    'longitude-voiceover_08.mp3',
    'longitude-voiceover_07.mp3',
    'longitude-voiceover_09.mp3',
    'longitude-voiceover_10.mp3',
    'longitude-voiceover_11.mp3',
];

const audio = Object.fromEntries(filenameArray.map(fn => [fn, undefined]));

export default audio;